/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
// components
import { Container } from 'components/Grid';

// styles
import {
  SegmentNavigationWrapper,
  NavList,
  ItemMenu,
  Image,
  Label,
} from './SegmentNavigation.styles';

export function SegmentNavigation() {
  return (
    <SegmentNavigationWrapper>
      <Container>
        <NavList>
          <ItemMenu href="/shipper/">
            <Image>
              <source
                srcSet={`/images/home/menu/nav-shippers.jpg`}
                media="(min-width: 768px)"
              />
              <img
                width="447"
                height="297"
                src={`/images/home/menu/nav-shippers-mobile.jpg`}
                alt="Shipper solutions"
              />
            </Image>
            <Label>Shippers</Label>
          </ItemMenu>
          <ItemMenu href="/carrier/">
            <Image>
              <source
                srcSet={`/images/home/menu/nav-carriers.jpg`}
                media="(min-width: 768px)"
              />
              <img
                width="447"
                height="297"
                src={`/images/home/menu/nav-carriers-mobile.jpg`}
                alt="Carrier solutions"
              />
            </Image>
            <Label>Carriers</Label>
          </ItemMenu>
          <ItemMenu href="/warehouse/">
            <Image>
              <source
                srcSet={`/images/home/menu/nav-warehouses.jpg`}
                media="(min-width: 768px)"
              />
              <img
                width="447"
                height="297"
                src={`/images/home/menu/nav-warehouses-mobile.jpg`}
                alt="Warehouse Solutions"
              />
            </Image>
            <Label>Docks & Yards</Label>
          </ItemMenu>
        </NavList>
      </Container>
    </SegmentNavigationWrapper>
  );
}
